export namespace Base64 {
	//-----------------------------------------------------------------------------
	//## validation

	export const regexp:Readonly<RegExp>	=
		Object.freeze(/^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/);

	//-----------------------------------------------------------------------------
	//## encoding

	// adds no whitespace to the output
	export const encode	= (self:Uint8Array):string	=> {
		const out:Array<string>	= [];

		// can overshot by 1 or 2 bytes, this is corrected later
		for (let pos=0; pos<self.length; pos+=3) {
			const i0	= self[pos+0];
			const i1	= self[pos+1];
			const i2	= self[pos+2];
			const o0	= (i0 >> 2) & 0x3f;
			const o1	= (i0 << 4) & 0x30 | (i1 >> 4) & 0x0f;
			const o2	= (i1 << 2) & 0x3c | (i2 >> 6) & 0x03;
			const o3	= (i2 << 0) & 0x3f;
			out.push(alphabet[o0]);
			out.push(alphabet[o1]);
			out.push(alphabet[o2]);
			out.push(alphabet[o3]);
		}

		// if we encoded too much, we replace it with padding characters here
		const extra	= self.length % 3;
		if (extra === 1) {
			out[out.length-1]	= "=";
			out[out.length-2]	= "=";
		}
		else if (extra === 2) {
			out[out.length-1]	= "=";
		}

		return out.join("");
	};

	//-----------------------------------------------------------------------------
	//## decoding

	// allows whitespace in the input
	export const decodeWs	= (base64:string):Uint8Array|null	=>
		decode(removeWs(base64));

	// does not allow whitespace in the input
	export const decode	= (base64:string):Uint8Array|null	=> {
		const chunks	= base64.length / 4;
		if (!Number.isSafeInteger(chunks))	return null;

		const padding	= base64.endsWith("==") ? 2 : base64.endsWith("=") ? 1 : 0;
		const length	= chunks * 3 - padding;
		const out		= new Uint8Array(length);
		for (let i=0; i<chunks; i++) {
			const x0	= decodeTable[base64.charCodeAt(i*4+0)];
			const x1	= decodeTable[base64.charCodeAt(i*4+1)];
			const x2	= decodeTable[base64.charCodeAt(i*4+2)];
			const x3	= decodeTable[base64.charCodeAt(i*4+3)];
			if (x0 === undefined	|| x1 === undefined || x2 === undefined || x3 === undefined)	return null;
			if (x0 === 0xff			|| x1 === 0xff		|| x2 === 0xff		|| x3 === 0xff)			return null;

			const b0	= (x0 << 2 & 0xfc) | (x1 >> 4 & 0x03);
			const b1	= (x1 << 4 & 0xf0) | (x2 >> 2 & 0x0f);
			const b2	= (x2 << 6 & 0xc0) | (x3 >> 0 & 0x3f);

			const last	= i === chunks-1;
			if (last && padding === 1) {
				if (x0 === 0xfe || x1 === 0xfe || x2 === 0xfe)					return null;
				out[i*3+0]	= b0;
				out[i*3+1]	= b1;
			}
			else if (last && padding === 2) {
				if (x0 === 0xfe || x1 === 0xfe)									return null;
				out[i*3+0]	= b0;
			}
			else {
				if (x0 === 0xfe || x1 === 0xfe || x2 === 0xfe || x3 === 0xfe)	return null;
				out[i*3+0]	= b0;
				out[i*3+1]	= b1;
				out[i*3+2]	= b2;
			}
		}
		return out;
	};

	export const removeWs	= (it:string):string	=>
		it.replace(/\s/g, "");

	//-----------------------------------------------------------------------------
	//## alphabet

	const alphabet	= "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

	// value of a 6-bit part for valid characters, 0xff for invalid characters, 0xfe for padding
	const decodeTable	= (() => {
		const out	= new Uint8Array(256);
		for (let i=0; i<256; i++) {
			out[i]	= alphabet.indexOf(String.fromCharCode(i));
		}
		out["=".charCodeAt(0)]	= 0xfe;
		return out;
	})();
}
